/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { useCallback, useMemo } from "react";
import {
  getMediaTagsByType,
  IMediaCategoryListModel,
  IMediaCategoryModel,
  UrlHelper,
} from "@nf/common";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";

import Dropdown from "components/Dropdown";

export type CategoryDropdownProps = {
  categories?: IMediaCategoryListModel;
  activeCategory: IMediaCategoryModel;
};

export const CategoryDropdown = ({
  categories,
  activeCategory,
}: CategoryDropdownProps) => {
  const { t } = useTranslation("translations");
  const router = useRouter();

  const options = useMemo(
    () =>
      getMediaTagsByType(categories?.Entities).map((category) => ({
        value: `${category.CategoryId}`,
        label: category.CategoryName,
      })),
    [categories?.Entities]
  );

  const onCategoryChange = useCallback(
    (categoryId?: string) => {
      router.push({
        search: UrlHelper.joinQueries(router.query, {
          id: categoryId,
        }),
      });
    },
    [router]
  );

  return (
    <Dropdown
      aria-label={t("web_select_categories")}
      prefix={t("web_select_categories")}
      value={`${activeCategory.CategoryId}`}
      options={options}
      onChange={onCategoryChange}
    />
  );
};

export default CategoryDropdown;
